import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgInfo = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M11.755 2a1.678 1.678 0 1 0 0 3.355 1.678 1.678 0 0 0 0-3.355M9.332 8.384a1.258 1.258 0 1 0 0 2.517h.746a.42.42 0 0 1 .419.42v7.549a2.936 2.936 0 0 0 2.936 2.935h1.957a1.258 1.258 0 1 0 0-2.516h-1.957a.42.42 0 0 1-.42-.42V11.32a2.936 2.936 0 0 0-2.935-2.936z"
      />
    </svg>
  );
};
export default SvgInfo;
